
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caseStudy",
      function () {
        return require("private-next-pages/caseStudy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/caseStudy"])
      });
    }
  